import React from 'react';

import BaseLayout from 'shared/ui/BaseLayout/BaseLayout';
import NotFoundPage from 'shared/ui/ErrorPage/NotFoundPage';
import {StatusPageView} from 'entities/statusView';

import usePublicUserReport from '../../model/usePublicUserReport';

const PublicUserReportScreen: React.FC = () => {
    const {data, isLoading, isNotFound} = usePublicUserReport();

    if (isLoading) {
        return <BaseLayout isLoading/>;
    }

    if (isNotFound || !data) {
        return <NotFoundPage/>;
    }

    return (
        <BaseLayout pageTitle={data.name}>
            <StatusPageView data={data} hideActions/>
        </BaseLayout>
    );
};

export default PublicUserReportScreen;
